import { Address } from '@ton/core'

export const shortenWalletAddress = (
  address: string,
  isTestnet: boolean,
): string => {
  try {
    const userFriendly = Address.parse(address).toString({
      bounceable: false,
      testOnly: isTestnet,
    })
    return `${userFriendly.slice(0, 4)}...${userFriendly.slice(-4)}`
  } catch {
    return `${address.slice(0, 4)}...${address.slice(-4)}`
  }
}
